/** @jsx jsx */
/* eslint-disable no-use-before-define */
import {jsx, css} from '@emotion/core'
import React from 'react'
import { useCalculator, STEPS } from './use-calculator'
import { SelectHolding } from './cusip-input/select-holding'
import { InputCusip } from './cusip-input/input-cusip'
import { mediaQueries, isCusip } from '../twd'

export const CusipInput = () => {
    const {
        step, cusip:cusip_, setCusip:setCusip_, holdings,
        setBondInfo, setCalcInput,  setCalcOutput
    } = useCalculator()

    const [cusip, setCusip] = React.useState(cusip_ || '')
    const [isError, setIsError] = React.useState(false)

    React.useEffect(() => {
        setCusip(cusip_)
        setIsError(false)
    }, [cusip_])

    const isShow = step===STEPS.CUSIP_INPUT || step===STEPS.CUSIP_ERROR
    if (!isShow) return null

    const onEnter = (value) => {
        const val = value && value.trim()
        if (!val || !isCusip(val)) {
            setIsError(true)
            return
        }

        setIsError(false)
        setCusip_(val)
        setBondInfo(null)
        setCalcInput(null)
        setCalcOutput(null)
    }

    return <React.Fragment>

        <div className="row vertical-offset-xs">
            <div className="col-md-12">
            <h3 className="subhead" style={{marginBottom: '0px'}}>Enter a CUSIP or select from your holdings</h3>
            </div>
        </div>

        <div className="row vertical-offset-xs">
        <div className="col-md-6 col-xs-12" css={selectCusipCss}>
            <InputCusip
                cusip={cusip}
                setCusip={setCusip}
                isError={isError}
                onEnter={onEnter}
            />
        </div>

        <div className="text-center" css={orCss}>or</div>

        <div className="col-md-6 col-xs-12" css={selectHoldingCss}>
            <SelectHolding
                cusip={cusip}
                setCusip={(newCusip) => {
                    setIsError(false)
                    setCusip(newCusip)
                }}
                holdings={holdings}
                isError={isError} />
        </div>
        </div>

        <div className="row vertical-offset-sm">
        <div className="col-md-4 xs-hide"></div>
        <div className="col-md-4 col-xs-12 text-center">
            <button
            className="btn btn-primary btn-block"
            type="button"
            onClick={() => {
                onEnter(cusip)
            }}>Get Data</button>
        </div>
        <div className="col-md-4 xs-hide"></div>
        </div>
        </React.Fragment>

}

const selectCusipCss = css`
    ${mediaQueries.notXs} {
        float: left;
        width: calc(50% - 10px);
        padding-right: 20px;
    }
`

const orCss = css`
    font-weight: 500;
    ${mediaQueries.notXs} {
        display: inline-block;
        max-width: 20px;
        margin-top: 25px;
        margin-left: 5px;
    }
    ${mediaQueries.xs} {
        margin-bottom:15px;
    }
`


const selectHoldingCss = css`
    ${mediaQueries.notXs} {
        float: right;
        padding-left: 20px;
        width: calc(50% - 10px);
    }
`



// WEBPACK FOOTER //
// ./src/calculator/cusip-input.js